import Commons from '../../../../Services/Common/Common';

/**
 * NOT_BASIC_01_01 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 *   - initial: 초기값
 *   - label: 필드명
 *   - required: 필수 입력 여부
 *   - requiredWhen: 언제 필수인지 조건
 *
 * - mapper: 조회/삭제 API payload 생성 규칙
 *   - mapParamsBySchema(mapper, context)로 payload를 만듬
 *   - context에는 userInfo 등이 들어오며(mapParamsBySchema에 기본족으로 정의되어 있음),
 *     화면에서 추가로 필요한 값(chaebunNo 등)을 context로 넘겨줄 수 있다.
 */
export const NOT_BASIC_01_01_Schema = {
  mapper: {
    search1: {
      ChaebunNo: (_, context) =>
        Commons.EncryptAES(context.chaebunNo || '') || '',
    },

    delete1: {
      ChaebunNo: (row) => Commons.EncryptAES(row.chaebunNo || '') || '',
    },
  },
};
